import { POLICY_NAMES } from '~app/shared/constants/policy-names.constants';
import { Brand } from '~app/shared/enums/brand.enum';
import { titleCase } from '~app/shared/functions/utils/utils.function';
import { IPolicyContent } from '~app/shared/services/mw/interfaces/GetEmployeeAgreementInfo.interface';

export class Policy {
  public data: IPolicyContent;

  constructor(data: any, public readonly brand: Brand) {
    this.data = data;
  }

  public get id(): keyof typeof POLICY_NAMES {
    return this.data.type as keyof typeof POLICY_NAMES;
  }

  public get title(): string {
    return titleCase(POLICY_NAMES[this.id] || 'No title found');
  }

  public get value(): string {
    return this.data.value || 'No content found';
  }

  public get version(): string {
    return this.data.version;
  }

  public get key(): string {
    return this.data.key;
  }
}
